module.exports = __webpack_public_path__ + "img/erweima.8de96e80.jpg";